const formatCardNumber = (value) => {
  // 1. 移除所有非数字字符
  const cleanValue = value.replace(/\D/g, '');
  // 2. 每4位添加一个 '-'
  // (?=\d) 是前瞻断言，确保后面还有数字才加分隔符，避免末尾多出一个 '-'
  // return cleanValue.replace(/(\d{4})(?=\d)/g, '$1-');
  return `#${cleanValue}`
};

const minin = {
  data() {
    return {
      baseUrl: 'staff',
      viewMode: false,
      form: {
        name: undefined,
        sex: '男',
        birthday: undefined,
        tel: undefined,
        nation: undefined,
        province: undefined,
        address: undefined,
        contact: undefined,
        contacttel: undefined,
        identitycard: undefined,
        username: undefined,
        password: undefined,
      },
      rules: {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        birthday: [
          { required: true, message: "请选择出生年月", trigger: "blur" },
        ],
        tel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        nation: [
          { required: true, message: "请填写民族", trigger: "blur" },
        ],
        province: [
          { required: true, message: "请填写籍贯", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请填写住址", trigger: "blur" },
        ],
        contact: [
          { required: true, message: "请填写紧急联系人姓名", trigger: "blur" },
        ],
        contacttel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        username: [
          { required: true, message: "请填写账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
      },
      formGroups: [
        {
          title: '基础信息',
          formCtrl: [
            {
              label: "姓名",
              keyName: "name",
              err: "请填写姓名",
              type: "text",
            },
            {
              label: "性别",
              keyName: "sex",
              err: "请选择性别",
              type: "select",
              options: [
                { label: '男', value: '男' },
                { label: '女', value: '女' },
              ],
            },
            {
              label: "出生年月",
              keyName: "birthday",
              err: "请选择出生年月",
              type: "date",
            },
            {
              label: "入职时间",
              keyName: "entrytime",
              err: "请选择入职时间",
              type: "date",
            },
            {
              label: "状态",
              keyName: "iswork",
              err: "请选择状态",
              type: "select",
              options: [],
            },
            {
              label: "学历",
              keyName: "edu",
              err: "请选择学历",
              type: "select",
              options: [],
            },
            {
              label: "联系方式",
              keyName: "tel",
              err: "请填写联系方式",
              type: "text",
            },
            {
              label: "民族",
              keyName: "nation",
              err: "请填写民族",
              type: "text",
            },
            {
              label: "籍贯",
              keyName: "province",
              err: "请填写籍贯",
              type: "text",
            },
            {
              label: "住址",
              keyName: "address",
              err: "请填写住址",
              type: "text",
            },
            {
              label: "紧急联系人",
              keyName: "contact",
              err: "请填写紧急联系人姓名",
              type: "text",
            },
            {
              label: "紧急联系人联系方式",
              keyName: "contacttel",
              err: "请填写紧急联系人联系方式",
              type: "text",
            },
            {
              label: "身份证正反面",
              keyName: "identitycard",
              type: "file",
              tips: "最多上传2张图片",
              max: 2,
              className: "block",
            },
            {
              label: "无犯罪记录证明",
              keyName: "not_crime",
              type: "file",
              tips: "最多上传2张图片",
              max: 2,
              className: "block",
            }
          ],
        },
        {
          title: '账号信息',
          formCtrl: [
            {
              label: "账号",
              keyName: "username",
              err: "请填写账号",
              type: "text",
            },
            {
              label: "密码",
              keyName: "password",
              err: "请填写密码",
              type: "password",
            },
          ],
        },
      ],
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }

      const opt = this.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'staff',
      }
    },

    getOptions(params = {}) {
      this.post(`${this.baseUrl}/addpro`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions({ iswork, edu }) {
      this.formGroups[0].formCtrl.map(c => {
        if (c.keyName == 'iswork' && iswork) {
          for (const key in iswork) {
            if (Object.hasOwnProperty.call(iswork, key)) {
              const val = iswork[key];
              c.options.push({
                label: val,
                value: key,
              })
            }
          }
          if (!this.form.name) this.form.iswork = '1'
          // console.log([...c.options])
          // console.log({...this.form})
        }
        if (c.keyName == 'edu' && edu.length) {
          c.options = edu.map(v => {
            return {
              label: v.eduname,
              value: v.eduname,
            }
          })
          if (!this.form.name) this.form.edu = edu[0].eduname
        }
      })
    },
    setDetail() {
      const formCtrl = [...this.formGroups[0].formCtrl]
      if (this.formGroups[1]) {
        formCtrl.push(...this.formGroups[1].formCtrl)
      }
      formCtrl.map(v => {
        const key = v.keyName
        if (['iswork'].includes(key)) {
          this.form[key] = this.detail[key] + ''
        } else {
          this.form[key] = this.detail[key];
        }
      })
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    onChange({ key, value }) {
      // console.log(key, value)
      if (key === 'deposit_status_str') {
        this.form['deposit_status'] = 1
        if (value == '已扣除') {
          this.form['deposit_status'] = 2
        } else if (value == '已归还') {
          this.form['deposit_status'] = 3
        }
      } else if (key === 'bank_card_no') {
        const val = formatCardNumber(value)
        // console.log(key, value)
        // console.log(val)
        this.form[key] = val
      } else {
        this.form[key] = value;
      }
      // console.log('form', { ...this.form });
    },
  },
  mounted() {
    if (this.mode === 'edit') {
      this.formGroups[1].formCtrl.map(c => {
        if (c.keyName == 'username') {
          c.disabled = true
        }
      })
    }
  },
}

export default minin